


























































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ItemTagFormDialog from '@/components/item/ItemTagFormDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

import { ErrorManager } from '@/models/error';
import { ITag, Tag } from '@/models';

import { DataTableHeader } from 'vuetify';
import ALPage from '@/components/core/Page/ALPage.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    itemTagFormDialog: InstanceType<typeof ItemTagFormDialog>;
  };
}

export default Vue.extend<Options>({ functional: false }).extend({
  components: {
    ErrorAlert,
    ItemTagFormDialog,
    ConfirmationDialog,
    ALPage
  },

  data() {
    return {
      search: '',
      loading: false,

      errorMessage: '',
      detailErrorMessage: '',
      deleteErrorMessage: '',

      options: {
        showFirstLastPage: true,
        itemsPerPageOptions: [100]
      },
      page: 1,

      deleteInProgress: false,
      deleteDialog: false,
      selectedTag: null as null | ITag
    };
  },

  computed: {
    ...mapGetters({
      tags: 'itemTag/getTags'
    }),

    tagHeaders(): DataTableHeader[] {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'actions', width: 80 },
        {
          text: '',
          value: 'spacer',
          sortable: false,
          width: 50
        }
      ];
    }
  },

  mounted() {
    this.loading = true;
    this.fetchTags()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchTags: 'itemTag/fetchTags',
      deleteTag: 'itemTag/deleteTag'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
      this.clearAllDeleteErrors();
    },

    clearAllDeleteErrors(): void {
      this.deleteErrorMessage = '';
    },

    createTag() {
      this.$refs.itemTagFormDialog.open();
    },

    editRecord(tag: Tag) {
      this.$refs.itemTagFormDialog.open(tag);
    },

    deleteRecord(tag: Tag) {
      this.clearAllErrors();
      this.selectedTag = tag;
      this.deleteDialog = true;
    },

    cancelTagDeleteDialog() {
      this.selectedTag = null;
      this.deleteDialog = false;
    },

    removeTag(tag: ITag) {
      this.clearAllDeleteErrors();
      this.deleteInProgress = true;

      this.deleteTag(tag.id)
        .then(() => {
          this.deleteDialog = false;
        })
        .catch(error => {
          this.deleteErrorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.deleteInProgress = false;
        });
    }
  }
});
